import { render, staticRenderFns } from "./ContractDetailView.vue?vue&type=template&id=5fd90082&scoped=true&"
import script from "./ContractDetailView.vue?vue&type=script&lang=js&"
export * from "./ContractDetailView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=5fd90082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd90082",
  null
  
)

export default component.exports